import { GermplasmPairModel } from './germplasm-pair.model';
import { GermplasmPairTraitModel } from './germplasm-pair-trait.model';
import { Weight } from '../../shared/query/model/weight.model';

export class VariableResultsRequestModel {
    constructor(public germplasmPairs?: GermplasmPairModel[],
                public traits?: GermplasmPairTraitModel[],
                public environments?: Environment[]) {
    }
}

export class Environment {
    constructor(public environmentId: number,
                public weight?: Weight) {
    }
}